/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ExternalTrustTypeRequestTrustType =
  typeof ExternalTrustTypeRequestTrustType[keyof typeof ExternalTrustTypeRequestTrustType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalTrustTypeRequestTrustType = {
  BARE_TRUST: 'BARE_TRUST',
  INTEREST_IN_POSSESSION_TRUST: 'INTEREST_IN_POSSESSION_TRUST',
  DISCRETIONARY_TRUST: 'DISCRETIONARY_TRUST',
  ACCUMULATION_TRUST: 'ACCUMULATION_TRUST',
  MIXED_TRUST: 'MIXED_TRUST',
  OTHER: 'OTHER',
} as const;
